import { createSlice } from '@reduxjs/toolkit';

const initiaTargetingLocationslState = { type: 'all_countries', selectedLocations: [] };

const targetingLocationsSlice = createSlice({
  name: 'targetingLocations',
  initialState: initiaTargetingLocationslState,
  reducers: {
    changeLocationsTargetingType: (state, action) => {
      state.type = action.payload;
    },
    changeSelectedLocations: (state, action) => {
      state.selectedLocations = action.payload;
    },
  },
});

export const targetingLocationsActions = targetingLocationsSlice.actions;
export default targetingLocationsSlice.reducer;
